import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';

/**
 * Wraps the authenticated half of the app. Redirects to /auth/sign-in
 * with a `redirect` param so the user lands back where they were
 * after signing in. Renders nothing while the cookie probe is still
 * in flight (a brief blank flash is preferable to the dashboard
 * paint-then-redirect dance).
 */
export default function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'loading') {
    return (
      <div
        aria-hidden
        className="min-h-screen bg-background"
      />
    );
  }
  if (status === 'unauthenticated') {
    const here = `${location.pathname}${location.search}`;
    return <Navigate to={`/auth/sign-in?redirect=${encodeURIComponent(here)}`} replace />;
  }
  return <Outlet />;
}
